import type {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';
import {cn} from '@common-web/lib/utils';

const TABS = [
  {to: '/enrollment-sites', label: 'Sites', end: true},
  {to: '/enrollment-sites/activity', label: 'Activity', end: false},
];

/**
 * Sites / Activity tabs under the Enrollment Sites header; each tab is its own route.
 * Fixed height so the content below starts in the same place on both tabs, whatever
 * sits in the right slot.
 */
export function EnrollmentSitesTabs({right}: {right?: ReactNode}) {
  return (
    <div className='-mt-2 flex h-10 items-end justify-between gap-4 border-b'>
      <nav className='flex gap-6' aria-label='Enrollment sites views'>
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({isActive}) =>
              cn(
                '-mb-px border-b-2 px-1 pb-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      {right && <div className='pb-1.5'>{right}</div>}
    </div>
  );
}
